import createProductSdk from '@b2ag/module-product-sdk'
import { buildCallerId } from '@invivodf/front-seller-caller-id'
import { useAuthService } from '@invivodf/front-seller-auth'

window.env = window.env || {}

export const productApiHost: string = (window.env as any).PRODUCT_API_HOST
const accessTokenSource = () => useAuthService().getAccessToken()

const productSdkOptions = {
  accessTokenSource,
  localeSource: () => 'fr-FR' as any,
  callerId: buildCallerId(),
}

export const productSdk = createProductSdk(productApiHost, productSdkOptions)

/**
 * Même SDK, mais plafonné à 20 s : c'est le timeout que portaient les clients axios
 * remplacés sur les écrans de lecture et d'export. Les imports gardent `productSdk`,
 * sans timeout, parce qu'un CSV volumineux dépasse largement ces 20 s.
 */
export const productSdkWithTimeout = createProductSdk(productApiHost, { ...productSdkOptions, timeout: 20000 })

/**
 * Sans `localeSource` : le client axios l'applique après les en-têtes de l'appel, il écraserait
 * l'`idf-locale` envoyé par `getDistributorSecuredKey` et le BFF renverrait l'index v3 fr-FR
 * quelle que soit la locale de la marque (alors que le nom v2 en dépend).
 */
export const securedKeyProductSdk = createProductSdk(productApiHost, { ...productSdkOptions, localeSource: undefined })
